import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/AddCompanySegmentsWizard.scss';
import autobind from 'autobind-decorator';
import { __, mapStateToProps, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import { withRouter } from 'react-router';
import * as _ from 'lodash';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
import {
  createCompanySegment,
  listCompanySegments,
} from '../redux/actions/table/company_segments';
import AddCompanyIcon from '../assets/images/add-company-60x60.svg';
import AddCompanySegmentsForm from '../forms/add_company_segments_wizard/AddCompanySegmentsForm';

@withRouter
@mapStateToProps((state) => ({
  table: state.table['company_segments'],
}))
@subscribe(Localization, 'localization')
class AddCompanySegmentsWizard extends Component {
  @autobind
  _handleSubmit(formData) {
    return validateForm(
      createCompanySegment(formData).then(({ response }) => {
        listCompanySegments();

        setNotification(__('wizard.add-company-segment.confirm'));

        this.props.onClose();
      })
    );
  }

  render() {
    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>{__('wizard.add-company-segments.title.create-new')}</span>
            <span>{__('wizard.add-company-segments.subtitle.create-new')}</span>
          </div>
          <div className={styles.right}>
            <AddCompanyIcon />
          </div>
        </div>
        <div className={styles.body}>
          <AddCompanySegmentsForm onSubmit={this._handleSubmit} />
        </div>
      </>
    );
  }
}

export default AddCompanySegmentsWizard;
